var EPK = EPK || {};
EPK.Hp = EPK.Hp || {};

EPK.Hp.$selectorBirthday = $('#birthdayYear, #birthdayMonth, #birthdayDay');
EPK.Hp.$birthday = $('#hdn_birthday');
EPK.Hp.$birthdayYear = $('#birthdayYear');
EPK.Hp.$birthdayMonth = $('#birthdayMonth');
EPK.Hp.$birthdayDay = $('#birthdayDay');

EPK.Hp.initEvent = function() {
	EPK.Hp.$selectorBirthday.on('click, change', function() {
		var $year = EPK.Hp.$birthdayYear.val();
		var $month = EPK.Hp.$birthdayMonth.val();
		var $day = EPK.Hp.$birthdayDay.val();
		EPK.Hp.$birthday.val($year + '-' + $month + '-' + $day);
	});
}

$(function() {
	EPK.Hp.initEvent();

	var mainSwiper;
	var $sliderShops = $("#slider-shops");
	var $slides = $sliderShops.find(".swiper-slide");

	var swiper = $('#slider-shops').swiper({
		centeredSlides: true,
		slidesPerView: 1,
		loop:true,
		pagination: "#slider-shops .swiper-pagination",
		paginationClickable: true,
		nextButton: "#slider-shops .slider-fwd",
		prevButton: "#slider-shops .slider-rev",

	});
});

$(function() {
	EPK.Hp.initEvent();

	var mainSwiper;
	var $sliderShops = $("#new_shops_slider");
	var $slides = $sliderShops.find(".swiper-slide");

	if(typeof effort_cnt !== 'undefined'){
		if(effort_cnt > 3){
			var swiper = $('#new_shops_slider').swiper({
				initialSlide: 0,
				loop: true,
				slidesPerView: 3,
				spaceBetween: 30,
				pagination: '.swiper-pagination',
				nextButton: '.swiper-button-next',
				prevButton: '.swiper-button-prev',
				autoplay: '5000',
				lazyLoading: true, // 左記を追加
				lazyLoadingInPrevNext: true,
				lazyLoadingInPrevNextAmount: 3,
				autoplayDisableOnInteraction: 'false'
			});
		}else{
			var swiper = $('#new_shops_slider').swiper({
				initialSlide: 0,
				loop: true,
				slidesPerView: 3,
				spaceBetween: 30,
				pagination: '.swiper-pagination',
				nextButton: '.swiper-button-next',
				prevButton: '.swiper-button-prev',
				lazyLoading: true, // 左記を追加
				lazyLoadingInPrevNext: true,
				lazyLoadingInPrevNextAmount: 3,
				autoplayDisableOnInteraction: 'false'
			});
		}
	}
});
